import React, { forwardRef, useEffect, useState } from 'react';
import { UX2 } from '@wsb/guac-widget-core';
import PropTypes from 'prop-types';
import { LAYERS } from '../../../constants/index';

const { Z_INDEX_WRAPPER } = LAYERS;

const generateStyles = (percentage, marginLeft) => ({
  container: {
    position: 'relative',
    height: 7,
    marginBottom: 6,
    ['@md']: {
      marginBottom: 0
    }
  },
  thumb: {
    width: 14,
    height: 14,
    boxShadow: '0px 0px 5px rgba(0, 0, 0, 0.1)',
    zIndex: Z_INDEX_WRAPPER + 1,
    backgroundColor: 'primary',
    position: 'absolute',
    borderRadius: '50%',
    top: '50%',
    transform: 'translate(0%, -50%)',
    pointerEvents: 'none',
    userSelect: 'none',
    left: `${percentage}%`,
    marginLeft: marginLeft,
    opacity: percentage > 0 ? 1 : 0
  },
  sliderContainer: {
    width: '100%',
    height: '100%',
    position: 'relative',
    overflow: 'hidden',
    borderRadius: 29,
    backgroundColor: 'sectionUltraLowContrast'
  },
  progress: {
    backgroundColor: 'primary',
    height: '100%',
    width: '100%',
    transform: `translateX(${percentage - 100}%)`
  },
  rangeInput: {
    webkitAppearance: 'none',
    position: 'absolute',
    top: 0,
    bottom: 0,
    right: 0,
    left: 0,
    width: '100%',
    cursor: 'pointer',
    opacity: 0,
    margin: '0 auto'
  }
});

const Progress = forwardRef((props, ref) => {
  const { updateDuration, handleTimeUpdate, onHasEnded, audioMeta } = props;
  const { type, url } = audioMeta;
  const [percentage, setPercentage] = useState(0);
  const marginLeft = (14 / 100) * percentage * -1;
  const styles = generateStyles(percentage, marginLeft);

  useEffect(() => {
    if (percentage === 100) {
      onHasEnded();
      setPercentage(0);
      handleTimeUpdate(0);
    }
  }, [percentage]);

  const onChange = e => {
    const audio = ref.current;
    audio.currentTime = (audio.duration / 100) * e.target.value;
    setPercentage(e.target.value);
  };

  const onTimeUpdate = e => {
    const percent = (e.currentTarget.currentTime / e.currentTarget.duration) * 100;
    setPercentage(percent);
    handleTimeUpdate(e.currentTarget.currentTime);
  };

  const onLoad = e => {
    updateDuration(e.currentTarget.duration.toFixed(2));
  };

  return (
    <UX2.Element.Block style={ styles.container }>
      <UX2.Element.Block style={ styles.thumb } />
      <UX2.Element.Block style={ styles.sliderContainer }>
        <UX2.Element.Block style={ styles.progress } />
        <input
          value={ percentage }
          onChange={ onChange }
          type='range'
          step='0.01'
          style={ styles.rangeInput }
        />
      </UX2.Element.Block>
      <audio onTimeUpdate={ onTimeUpdate } onLoadedMetadata={ onLoad } ref={ ref } preload='metadata'>
        <source type={ type } src={ url } />
        <track default kind='captions' />
      </audio>
    </UX2.Element.Block>
  );
});

Progress.propTypes = {
  updateDuration: PropTypes.func,
  handleTimeUpdate: PropTypes.func,
  onHasEnded: PropTypes.func,
  audioMeta: PropTypes.object
};

export default Progress;
